import { gql } from '@apollo/client';

export const GetCurrentRegionalCenterQuery = gql`
    query getCurrentRegionalCenter {
        getCurrentRegionalCenter {
            id
            name
            regions {
                id
                name
            }
            location {
                id
                name
            }
        }
    }
`;
